// Renders the FloorMatch circular logo. The image already contains the
// wordmark, so callers typically place it alone. Size via className.
// Sourced from /public/logo.png so CRA serves it at the site root.
export default function BrandMark({ className = "w-9 h-9", alt = "FloorMatch" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ""}/logo.png`}
      alt={alt}
      className={`${className} object-contain select-none`}
      draggable="false"
      data-testid="brand-logo"
    />
  );
}
